import { STRAPI } from "../loaders/global";
import Base from "./Base";
import YouTube from "react-youtube";
import Image from "./Image";

class Video extends Base {
  constructor(data) {
    super();
    if (data) this._patch(data);
  }
  _patch(data) {
    let d = data.attributes;
    this.id = data.id ?? null;
    this.name = d.name ?? "";
    this.link = d.link ?? "";
    this.thumbnail = new Image(d.thumbnail);
  }
  get display() {
    return <YouTube videoId={this.link} />;
  }
}

export default Video;
